import { Controller } from "react-hook-form";
import {  InputAdornment, TextField } from "@mui/material";


type Props = {
  control: any;
  name: string;
  label: string;
  defaultValue?: any;
  autoFocus?: boolean;
  errors: any;
  placeholder?: string;
  rules?: any;
  type?: string;
  disabled?: boolean;
  readonly?: boolean;
  adornment?: string;
};

const TextInput = ({ control, name, label, defaultValue = "", autoFocus = false, errors, placeholder = "", rules, type = "text", readonly = false, disabled = false, adornment } : Props) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules ? rules : undefined}
      render={({ field }) => (
        <TextField
          key="username"
          variant="outlined"
          label={label}
          autoFocus={autoFocus}
          size="small"
          fullWidth
          type={type}
          className="mb-3"
          placeholder={placeholder}
          {...field}
          error={errors[name] && true}
          helperText={
            errors[name] && (errors[name].message as string)
          }
          disabled={disabled}
          InputProps={{
            readOnly: readonly,
            endAdornment: adornment ? (
              <InputAdornment position="end">
                {adornment}
              </InputAdornment>
            ) : null,
          }}
        />
      )}
    />
  );
};

export default TextInput;